export const SAVE_ALL_APPRAISALS = 'SAVE_ALL_APPRAISALS'
